import { ApiUser } from "@api/interfaces";
import { AccountGroupRole } from '@shared/enums';
import { filterToViewableCustomers, getAccountName } from '@shared/utilities';
import { DashboardData } from '@/pages/CustomerDashboard/interfaces';

export const getUserDisplayName = (user: ApiUser) => {
  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }

  return user.businessName  || user.email || user.telephone || user.id;
};

export const sortLinkedAccounts = (linkedAccounts: ApiUser[]) => {
  const roleOrder: { [key in AccountGroupRole]: number } = {
    [AccountGroupRole.Primary]: 1,
    [AccountGroupRole.Partner]: 2,
    [AccountGroupRole.Secondary]: 3,
    [AccountGroupRole.IndependentPartner]: 4,
  };

  return linkedAccounts.sort((a, b) => {
    const roleComparison = roleOrder[a.accountGroupRole!] - roleOrder[b.accountGroupRole!];

    if (roleComparison !== 0) {
      return roleComparison;
    }

    const aAccountName = getAccountName(a);
    const bAccountName = getAccountName(b);
    return aAccountName.localeCompare(bAccountName);
  });
};

export const getAvailableCustomers = (
  dashboardData: DashboardData | undefined,
  options?: { maxLabelLength?: number },
): { id: string; label: string; subline?: string }[] => {
  const customers: { id: string; label: string; subline?: string }[] = [];
  const maxLength = options?.maxLabelLength ?? 30;
  
  const viewableAccounts = dashboardData
    ? filterToViewableCustomers(
      dashboardData.farmer,
      dashboardData.linkedAccounts,
    )
    : [];
  viewableAccounts.forEach((account) => {
    if (!account) return;
    const accountName = getAccountName(account);
    customers.push({
      id: account.id,
      label: accountName.length > maxLength ? `${accountName.substring(0, maxLength)}...` : accountName,
      subline: account.externalId ? `ID ${account.externalId}` : undefined,
    });
  });

  return customers;
};
